import React, { Fragment } from 'react'
import products from './products.json'
import { Card } from 'components/ui'
import { useTranslation } from 'react-i18next'
import Product from './components/Product'
import { useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'

function OurProducts() {
    const { t } = useTranslation()
    const navigate = useNavigate()
    const lang = useSelector((state) => state.locale.currentLang)

    const handleClick = (productId) => {
        navigate(`/${lang}/our-products/${productId}`)
    }

    return (
        <Fragment>
            <Card className="">
                <h1 className="flex justify-center items-center py-10">
                    {t('ourProducts:content.heading')}
                </h1>
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 2xl:grid-cols-3 gap-6">
                    {products.map((product, index) => (
                        <Product
                            key={index}
                            headerImageClassName="w-full h-[360px] transition-transform duration-300 transform hover:scale-105"
                            headerImageAlt={product.title}
                            imgSrc={product.imgSrc}
                            productTitle={product.title}
                            productCode={product.code}
                            productPrice={product.price[0].value.amount}
                            productDescription={product.description}
                            onClick={() => handleClick(product.id)}
                            btnText="Details"
                        />
                    ))}
                </div>
            </Card>
        </Fragment>
    )
}

export default OurProducts
